import ProductCard from './ProductCard';

interface Product {
  id: string;
  name: string;
  image: string;
  price: string;
  originalPrice?: string;
  discount?: string;
  badge?: string;
  link: string;
}

interface ProductSectionProps {
  title: string;
  products: Product[];
  icon?: string;
  gradient?: string;
}

export default function ProductSection({ title, products = [], icon = 'ri-gamepad-line', gradient = 'from-blue-600 to-cyan-600' }: ProductSectionProps) {
  return (
    <section className="py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* 標題區域 */}
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center gap-3">
            {/* 圖標裝飾 */}
            <div className={`w-10 h-10 flex items-center justify-center rounded-xl bg-gradient-to-br ${gradient} shadow-lg`}>
              <i className={`${icon} text-xl text-white`}></i>
            </div>
            
            {/* 標題 */}
            <div>
              <h2 className={`text-2xl font-bold bg-gradient-to-r ${gradient} bg-clip-text text-transparent`}>
                {title}
              </h2>
              <div className={`h-1 w-16 bg-gradient-to-r ${gradient} rounded-full mt-1`}></div>
            </div>
          </div>

          {/* 查看更多按鈕 */}
          <a
            href="#"
            className={`group flex items-center gap-2 px-5 py-2.5 rounded-xl bg-gradient-to-r ${gradient} text-white font-medium text-sm shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 whitespace-nowrap`}
            onClick={(e) => e.preventDefault()}
          >
            <span>查看更多</span>
            <i className="ri-arrow-right-line text-base group-hover:translate-x-1 transition-transform duration-300"></i>
          </a>
        </div>

        {/* 產品網格 */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 sm:gap-6">
          {products.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      </div>
    </section>
  );
}